module.exports = __webpack_public_path__ + "img/bag-cross.87d17971.svg";